import { GenesisApiError } from 'src/packages/api'

const getApiErrorTitle = (error: unknown): string => {
  if (error instanceof GenesisApiError) {
    return error.err.title
  }

  // Handle Axios network errors
  if (error && typeof error === 'object') {
    const err = error as any

    // Network error (no response from server)
    if (err.code === 'ERR_NETWORK' || err.message?.includes('Network Error')) {
      return 'Unable to connect to server. Please check your connection.'
    }

    // Connection refused or timeout
    if (err.code === 'ECONNREFUSED' || err.code === 'ETIMEDOUT') {
      return 'Server is unreachable. Please try again later.'
    }

    // CORS or other fetch errors
    if (err.message) {
      return err.message
    }
  }

  return 'Unknown Error'
}

export default getApiErrorTitle
